<template>
    <div class="bgc shiji">
        <div class="shiji_title">{{shiJiBox.shiJiTitle}}</div>
        <div class="shiji_box" v-show="this.shiJiBox.shiJiList[0] != undefined">
            <div class="marquee">
                <div class="marquee_box" ref="marquee_box">
                    <ul class="marquee_list" :class="{marquee_top:animate}">
                        <li v-for="(item,index) in shiJiBox.shiJiList" :key="index">{{item}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="shiji_box" v-show="this.shiJiBox.shiJiList[0] == undefined">
          <span class="noTxt"
                style="line-height:10vh;margin-left:45%">暂无调研数据</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        shiJiBox: {}
    },
    data() {
        return {
            animate: false,
            showNum: 1, // 可见列表条数
        }
    },
    created() {
        // 页面显示
        if (this.shiJiBox.shiJiList[0] != undefined) {
          setInterval(this.showMarquee, 4000)
        }
    },
    mounted() {
        // 可见数据高度
        this.$refs.marquee_box.style.height = this.showNum * 9 + 'vh'
    },
    methods: {
        // 处理数组方法
        showMarquee() {
            this.animate = true
            this.shiJiBox.shiJiList.push(this.shiJiBox.shiJiList[0])
            setTimeout(() => {
                this.shiJiBox.shiJiList.shift()
                this.animate = false
            }, 2000)
        }
    }
}
</script>

<style lang="less" scoped>
.shiji {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 3;
    margin: 1vh;
    width: 41%;
    height: 16vh;

    .shiji_title {
        margin: 1% 3%;
        font-size:calc(100vw * 24 / 1920);
        font-weight: 700;
        border-bottom: 1px solid #333;
    }

    .shiji_box {
        .marquee {
            width: 100%;
            //  height: 200px; 
            align-items: center;
            color: #3a3a3a;
            // background-color: white;
            display: flex;
            box-sizing: border-box;
            overflow: hidden;
        }

        .marquee_title {
            padding: 0;
            height: 0;
            font-size:calc(100vw * 18 / 1920);
            border-right: 1px solid #d8d8d8;
            align-items: center;
        }

        .marquee_box {
            display: block;
            position: relative;
            width: 100%;
            overflow: hidden;
            margin: 2% 0 0 0%;
        }

        .marquee_list {
            display: block;
            position: absolute;
            top: 0px;
            left: 0;
        }

        .marquee_top {
            transition: all 2s;
            margin-top: -14vh;
        }

        .marquee_list li {
            // height: 50px;
            margin-bottom: 3vh;
            font-size:calc(100vw * 18 / 1920);
            padding-left: 20px;
        }

        .marquee_list li span {
            padding: 0 2px;
        }
    }
}
</style>